export default "__VITE_ASSET__DNC8Gb6u__"